import { EventsActionTypes, EventsActionType, EventsState } from './types'

const initialState: EventsState = {
  all: [],
  errorMsg: '',
  loading: false,
}

export function EventsReducer(
  state = initialState,
  action: EventsActionType
): EventsState {
  switch (action.type) {
    case EventsActionTypes.GET_EVENTS_REQUEST:
      return { ...state, loading: true }
    case EventsActionTypes.GET_EVENTS_SUCCESS:
      return { ...state, all: action.response, loading: false, errorMsg: '' }
    case EventsActionTypes.GET_EVENTS_FAILURE:
      return { ...state, errorMsg: action.errorMsg, loading: false }

    case EventsActionTypes.CREATE_EVENT_REQUEST:
    case EventsActionTypes.UPDATE_EVENT_REQUEST:
    case EventsActionTypes.DELETE_EVENT_REQUEST:
      return { ...state, loading: true }

    case EventsActionTypes.CREATE_EVENT_SUCCESS:
    case EventsActionTypes.UPDATE_EVENT_SUCCESS:
    case EventsActionTypes.DELETE_EVENT_SUCCESS:
      return { ...state, loading: false, errorMsg: '' }

    case EventsActionTypes.CREATE_EVENT_FAILURE:
    case EventsActionTypes.UPDATE_EVENT_FAILURE:
    case EventsActionTypes.DELETE_EVENT_FAILURE:
      return { ...state, errorMsg: action.errorMsg, loading: false }

    default:
      return state
  }
}
